import { isNumeric } from './isNumeric';

/**
 * Returns a promise that resolves after specified seconds
 * @param {number} seconds
 * @returns {Promise}
 */
export function wait(seconds: number): Promise<void> {
  if (!isNumeric(seconds)) {
    throw new Error('waitThen(seconds) requires a numeric argument.');
  }
  seconds = Number(seconds);
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, 1000 * seconds);
  });
}
